import type { MouseEvent, PropsWithChildren } from "react";

import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

import { useDropdown } from "@/contexts/DropdownContext";

type Props = { className?: string; attention?: "danger" } & (
  | { onClick: (event: MouseEvent<HTMLButtonElement>) => void; disabled?: boolean }
  | { popoverTarget: string }
  | { href: string }
  | { to: string }
  | { disabled: true }
);

export function MenuItem({ children, attention, className, ...options }: PropsWithChildren<Props>) {
  const dropdown = useDropdown();

  if ("to" in options) {
    return (
      <Link
        className={twMerge(
          "relative flex flex-row items-center gap-4 border-y border-transparent p-4 text-start font-interest not-disabled:cursor-pointer",
          attention === "danger" &&
            "bg-danger/5 text-danger hover:not-disabled:border-danger/20 hover:not-disabled:bg-danger/10 disabled:grayscale-25",
          attention === undefined &&
            "hover:not-disabled:border-divider hover:not-disabled:bg-black/5 disabled:bg-black/2 disabled:text-placeholder",
          className,
        )}
        onClick={() => dropdown.current?.hidePopover()}
        {...options}
      >
        {children}
      </Link>
    );
  }
  if ("href" in options) {
    return (
      <a
        className={twMerge(
          "relative flex flex-row items-center gap-4 border-y border-transparent p-4 text-start font-interest not-disabled:cursor-pointer",
          attention === "danger" &&
            "bg-danger/5 text-danger hover:not-disabled:border-danger/20 hover:not-disabled:bg-danger/10 disabled:grayscale-25",
          attention === undefined &&
            "hover:not-disabled:border-divider hover:not-disabled:bg-black/5 disabled:bg-black/2 disabled:text-placeholder",
          className,
        )}
        {...options}
      >
        {children}
      </a>
    );
  }
  return (
    <button
      type="button"
      className={twMerge(
        "relative flex flex-row items-center gap-4 border-y border-transparent p-4 text-start font-interest not-disabled:cursor-pointer",
        attention === "danger" &&
          "bg-danger/5 text-danger hover:not-disabled:border-danger/20 hover:not-disabled:bg-danger/10 disabled:grayscale-25",
        attention === undefined &&
          "hover:not-disabled:border-divider hover:not-disabled:bg-black/5 disabled:bg-black/2 disabled:text-placeholder",
        className,
      )}
      {...options}
    >
      {children}
    </button>
  );
}
